/**
 * @type interface
 */
export interface IStoreState {
	foo: string;
	languageCode: string;
	queryParameters: IQueryParameters;
}

/**
 * @class State
 * @package Store
 * @project ChalkySticks
 */
const state: IStoreState = {
	foo: 'bar',
	languageCode: 'en-US',
	queryParameters: {},
};

export default state;
